/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router';
// material
import { Page, Subhead, Content, BubbleNav, InContentMessage } from '@insticator/insticator-ui'; // iui-material
// pages
import General from 'pages/dashboard/account/general/general_container';
import Users from 'pages/dashboard/account/users/users_container';
import Sites from 'pages/dashboard/account/sites/sites_container';
import PaymentInfo from 'pages/dashboard/account/paymentinfo/paymentinfo_container';
import Adstxt from 'pages/dashboard/account/adstxt/adstxt_container';
// utils
import { PrivateRoute } from '@insticator/insticator-ui'; // iui-utils
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/account/account_styles';



/* ========== ~~~~~~~~~~ ACCOUNT ~~~~~~~~~~ ========== */
class Account extends Component {
    // _getPermittedPath is used to ensure user navigates to the first permitted tab.
    // If user doesn't have permissions to see any settings they will be redirected to the 403 error page
    _getPermittedPath = () => {
        // permissionToLink contains tab's permissions. The object ordered the same way tabs are ordered on screen.
        const permissionToLink = { generalPermitted: 'general', usersPermitted: 'users', sitesPermitted: 'sites',
            adsTxtPermitted: 'adstxt', paymentInfoPermitted: 'paymentinfo' };
        for (let permission of Object.keys(permissionToLink)) {
            if(this.props[permission]) return `/dashboard/account/${permissionToLink[permission]}`;
        }

        return `/error/403`;
    };
    render() {
        if(this.props.permissions.length < 1) return null; // Waits for permissions.
        return(
            <Page name={`account`} klass={`${this.props.classes.account}`}>
                <Subhead>
                    <h1>Account Settings</h1>
                </Subhead>
                <BubbleNav
                    name={'subnav'}
                    items={[
                        { name: 'general', text: 'General', icon: 'building', type: 'internal', action: 'dashboard/account/general', permitted: this.props.generalPermitted },
                        { name: 'users', text: 'Users', icon: 'users', type: 'internal', action: 'dashboard/account/users', permitted: this.props.usersPermitted },
                        { name: 'sites', text: 'Sites', icon: 'link', type: 'internal', action: 'dashboard/account/sites', permitted: this.props.sitesPermitted },
                        { name: 'ads', text: 'Ads.txt', icon: 'file', type: 'internal', action: 'dashboard/account/adstxt', permitted: this.props.adsTxtPermitted },
                        { name: 'payment', text: 'Payment Information', icon: 'credit-card', type: 'internal', action: 'dashboard/account/paymentinfo', permitted: this.props.paymentInfoPermitted }
                    ]}
                />
                <InContentMessage/>
                <Content>
                    <Switch>
                        {/*Routes to subsections*/}
                        <Route exact path='/dashboard/account' render={() => <Redirect to={this._getPermittedPath()} />} />
                        <PrivateRoute permitted={this.props.generalPermitted} path='/dashboard/account/general' component={General} />
                        <PrivateRoute permitted={this.props.usersPermitted} path='/dashboard/account/users' component={Users} />
                        <PrivateRoute permitted={this.props.sitesPermitted} path='/dashboard/account/sites' component={Sites} />
                        <PrivateRoute permitted={this.props.adsTxtPermitted} path='/dashboard/account/adstxt' component={Adstxt} />
                        <PrivateRoute permitted={this.props.paymentInfoPermitted} path='/dashboard/account/paymentinfo' component={PaymentInfo} />
                        <Redirect to='/error/404' />
                    </Switch>
                </Content>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Account);
